export const breakpoints = {
  huge: "1440px",
  large: "1170px",
  medium: "768px",
  small: "450px",
};
